import {
  calendarYmdInTimeZone,
  dateOnlyPickerWallDateToUtc,
  utcToDateOnlyPickerWallDate,
  zonedDateTimeToUtcDate,
} from "src/utils/timezone";

/**
 * Calendar date only (`yyyy-mm-dd`). Digits are interpreted in the user's
 * stored IANA timezone (see `timezone.ts` bridge helpers).
 */
export type CivilDateYmd = string;

function pad2(n: number): string {
  return `${n}`.padStart(2, "0");
}

export function formatCivilDateYmd(
  year: number,
  month: number,
  day: number
): CivilDateYmd {
  return `${year}-${pad2(month)}-${pad2(day)}`;
}

export function parseCivilDateYmd(
  s: string
): { year: number; month: number; day: number } | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
  if (!m) return null;
  const year = parseInt(m[1], 10);
  const month = parseInt(m[2], 10);
  const day = parseInt(m[3], 10);
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  return { year, month, day };
}

/** MUI picker `Date` for display for `ymd` in `timeZone`. */
export function civilDateYmdToPickerDate(
  ymd: CivilDateYmd,
  timeZone: string
): Date | null {
  const p = parseCivilDateYmd(ymd);
  if (!p) return null;
  const utc = zonedDateTimeToUtcDate(
    {
      year: p.year,
      month: p.month,
      day: p.day,
      hour: 12,
      minute: 0,
      second: 0,
      millisecond: 0,
    },
    timeZone
  );
  return utcToDateOnlyPickerWallDate(utc, timeZone);
}

/** From MUI picker `Date`: civil yyyy-mm-dd in `timeZone`. */
export function pickerDateToCivilDateYmd(
  d: Date,
  timeZone: string
): CivilDateYmd {
  const utc = dateOnlyPickerWallDateToUtc(d, timeZone);
  return calendarYmdInTimeZone(utc, timeZone);
}
